import React, { Component, Fragment } from 'react';
import {withRouter} from 'react-router-dom';
import Loading from '../../../../hoc/Loading/Loading';
import axios from '../../../../axios';
import * as actionCreators from '../../../../modules/actions/index';
import { connect } from 'react-redux';
import { Card, CardBody, CardImg, CardTitle, CardText, Input, Row, Col } from "reactstrap";



class InsightTitle extends Component {
  constructor(props) {
    super(props);
    this.state = { 
        name:this.props.singleNote&&this.props.singleNote.name?this.props.singleNote.name:
        this.props.reports&&this.props.reports.temp&&this.props.reports.temp.name?this.props.reports.temp.name:
        '',
        actionType: this.props.actionType
     }
     this.inputRef = React.createRef();
     this.timer = null;

  }
  
  componentDidMount(){
    // this.getAttachedItems()
    let {name} = this.props.reports&&this.props.reports.temp&&this.props.reports.temp.name?this.props.reports.temp:{name:''}
    console.log('name: ', name)
    this.setState({name})
  }

componentDidUpdate(prevProps){
  // let name =this.props.reports&&this.props.reports.temp&&this.props.reports.temp.name?this.props.reports.temp.name:''
  // let prevName = prevProps.reports&&prevProps.reports.temp&&prevProps.reports.temp.name?prevProps.reports.temp.name:''
  // if(name!="" && prevName !=name){
  //   this.setState({name})
  // }

  if(prevProps.actionType!= this.props.actionType){
    this.setState({actionType:this.props.actionType})
  }
}




updateReportName = company_name =>{
  this.props.createDashboardReport(company_name)
}


handleChangeInsightTitle = (event) => {
    const { value } = event.target;
    let{isFirstSection}=this.props
    let result = {name:value}
    if(isFirstSection){
      clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          this.updateReportName({ company_name:value });
        }, 2000);
    }

    this.setState(result)
    // this.props.changeReportTitle({company_name: value})
}




submitInsightTitle= () =>{
let{name}=this.state
this.props.submitChartInsight(name)
}


openCreateChartReport=()=>{
  this.props.openCreateChartReport()
}

removeReport=()=>{
  this.props.removeReport()
}


returnName(){
  console.log('inputRef: ', this.inputRef.value)
  return this.state.name
}

renderView=()=>{
  let{name,actionType}=this.state

  let{placeholderTxt,isSection,isContext}=this.props

  if(isSection){
    return (
      <div className="" >        

     {this.props.isFirstSection!=true?
      <span className="singleReportDashboardContainerOptions">
          <span className={`singleReportViewContainerBtn ${isContext?'btn-warning' :'btn-danger'}`}
          onClick={()=>this.removeReport()}> {isContext?"Remove Content":"Remove Section"} <i className='flaticon-trash'/> </span>
      </span>
      :null
    }

      {isContext!=true?
                  <div className="singleInsightAddTitleContainer">
                  <Input type="text" 
                      onChange={this.handleChangeInsightTitle} 
                      value={name}
                      ref={this.inputRef}
                      placeholder={placeholderTxt?placeholderTxt:'Company Name'} 
                      className="singleInsightAddTitleInput" maxLength={64} /> 
                  </div>
                  :null}

          </div>
    )
  }
  
  
  if(actionType=='VIEW'){
      return(<span>
          <div className="singleInsightViewTitle"> {name} </div>
        </span>)
  } else if (actionType=='EDIT') {
    return (
      <div className="" >
            
            <span className="singleReportDashboardContainerOptions">
             
            <span className="singleReportViewContainerBtn btn-outline-info"
             onClick={()=>this.props.changeInsightAction('VIEW')}> View <i className='flaticon-vision'/> </span>

                <span className="singleReportViewContainerBtn btn-success"
                onClick={()=>this.submitInsightTitle()}> Save <i className='flaticon-edit'/> </span>

                  <span className="singleReportViewContainerBtn btn-outline-primary"
                  onClick={()=>this.props.changeInsightAction('CREATE')}> Add Report 
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                      <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                    </svg>
                  </span>

                <span className="singleReportViewContainerBtn btn-outline-secondary"
                onClick={()=>this.openCreateChartReport()}> All Reports <i className='flaticon-paper'/> </span>
                </span>
                        <div className="singleInsightAddTitleContainer">
                        <Input type="text" onChange={this.handleChangeInsightTitle} 
                            value={name}
                            placeholder={'Report name'} 
                            className="singleInsightAddTitleInput" maxLength={64} /> 
                        </div>
      </div>
    )
  } else {
    
    return (
      <div className="" >        

      <span className="singleReportDashboardContainerOptions">

          <span className="singleReportViewContainerBtn btn-primary"
          onClick={()=>this.submitInsightTitle()}> Add Report <i className='flaticon-edit'/> </span>


          <span className="singleReportViewContainerBtn btn-outline-secondary"
          onClick={()=>this.openCreateChartReport()}> All Reports <i className='flaticon-close'/> </span>
        </span>


                  <div className="singleInsightAddTitleContainer">
                  <Input type="text" onChange={this.handleChangeInsightTitle} 
                      value={name}
                      placeholder={'Report Name'} 
                      className="singleInsightAddTitleInput" maxLength={64} /> 
                  </div>
          </div>
    )
  }
}

 
render() { 
    return  this.renderView() 
}


}




const mapStateToProps = state => {
  return {
    user: state.user,
    kpiMaster: state.kpiMaster,
    mappingMaster: state.mappingMaster,
    reports:state.reports,
    insights: state.reports.insights
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onKpiMasterListFetched: (data) => dispatch(actionCreators.storeKpiMaster(data)),
    onMappingMasterListFetched: (data) => dispatch(actionCreators.storeMappingMaster(data)),
    onProfileUpdate: (data) => dispatch(actionCreators.updateProfileInfoSuccess(data)),
    updateNavBar: (header) => dispatch(actionCreators.navBarUpdate(header)),
    updateReportCharts:(dashboard)=> dispatch(actionCreators.updateReportCharts(dashboard)),
    createDashboardReport:(dashboard)=> dispatch(actionCreators.createDashboardReport(dashboard)),
  }
}
 
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Loading(InsightTitle, axios)));



